function initPhoneInputs(root) {
    if (typeof window.intlTelInput !== 'function') {
        return;
    }

    var scope = root || document;
    var inputs = scope.querySelectorAll('input[type="tel"], input[name="phone"]');

    Array.prototype.forEach.call(inputs, function(input) {
        if (input.dataset.phoneInputReady === '1') {
            return;
        }

        input.dataset.phoneInputReady = '1';
        input.setAttribute('type', 'tel');

        var iti = window.intlTelInput(input, {
            initialCountry: 'sk',
            countryOrder: ['sk', 'cz', 'pl', 'at', 'hu'],
            separateDialCode: true
        });

        var form = input.closest('form');

        if (!form) {
            return;
        }

        form.addEventListener('formdata', function(event) {
            if (!input.name || !event.formData.has(input.name) || !input.value.trim()) {
                return;
            }

            event.formData.set(input.name, iti.getNumber());
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initPhoneInputs(document);
});

if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document).ajaxComplete(function() {
        initPhoneInputs(document);
    });
}
